import { Buffer } from 'buffer/';
// @ts-expect-error Typescript can't find the lib
import crypto from 'crypto-browserify';
import { decamelizeKeys } from './object';

function rsaEncrypt(plaintext: string, publicKey: string): string {
    const buffer = new Buffer(plaintext);
    const encrypted = crypto.publicEncrypt(
        {
            key: publicKey,
            padding: crypto.constants.RSA_PKCS1_PADDING,
        },
        buffer
    );
    return encrypted.toString('base64');
}

function aesCbcEncrypt(plaintext: string, key: string, iv: string): string {
    const cipher = crypto.createCipheriv('aes-256-cbc', key, iv);
    let encrypted = cipher.update(plaintext, 'utf8', 'base64');
    encrypted += cipher.final('base64');
    return encrypted;
}

export function encryptForSafeTraffic(
    object: Record<string, unknown>,
    publicKey: string,
    decamelize = true
): string {
    const aesKey = crypto.randomBytes(32);
    const iv = crypto.randomBytes(16);
    const str = JSON.stringify(decamelize ? decamelizeKeys(object) : object);
    const value = aesCbcEncrypt(str, aesKey, iv);
    const cipherKeyIv = rsaEncrypt(
        `${aesKey.toString('base64')}|${iv.toString('base64')}`,
        publicKey
    );
    return new Buffer(`${cipherKeyIv}:${value}`).toString('base64');
}
